<header class="header-area-wrapper transparent-header sticky-header" >
  <div class="container-fluid">
      <div class="row">
          <!-- Start Logo Area Wrap -->
          <div class="col-6 col-lg-2">
            <a href="index.html" class="logo-wrap d-block">
              <img src="assets/img/muni-logo-gchc.png" alt="White Logo">
              <img src="assets/img/muni-logo-gchc.png" class="sticky-logo" alt="Black Logo">
            </a>
          </div><!-- End Logo Area Wrap -->
          <!-- Start Main Navigation Wrap -->
          <div class="col-6 col-lg-10 my-auto ml-auto position-static">
              <div class="header-right-area d-flex justify-content-end align-items-center">
                  <div class="navigation-area-wrap d-none d-lg-block">
                      <nav class="main-navigation">
                          <ul class="main-menu nav justify-content-end">

                              <li class="dropdown-navbar"><a href="/inicio">Inicio</a>
                              </li>
                              <li class="dropdown-navbar arrow"><a href="/catalogacion">Catalogación</a>
                                <ul class="dropdown-nav">
                                    <li><a href="/catalogacion">Catalogación Inmuebles Urbanos</a></li>
                                    <li><a href="/inmuebles-religiosos">Catalogación Inmuebles Religiosos</a></li>
                                    <li><a href="/ambientes-urbanos">Catalogación Ambientes Urbanos</a></li>
                                    <li><a href="/inmaterial">Inmaterial</a></li>
                                    <li><a href="/fototeca">Fototeca</a></li>

                                </ul>
                              </li>
                              <li class="dropdown-navbar"><a href="/gestionriesgos">Gestión de Riesgos </a></li>

                              <li class="dropdown-navbar arrow"><a href="#">Libros</a>
                                <ul class="dropdown-nav">
                                    <li><a href="/libroriesgos">Libro Gestión de Riesgos</a></li>
                                    <li><a href="/libro">Libro Catalogación</a></li>
                                    <li><a href="/guia">Guía</a></li>
                                    <li><a href="/leandroalvinia">Leandro Alviña</a></li>
                                    <li><a href="/tuyrotupac">Juán Tomás Tuyro Tupac</a></li>

                                </ul>
                              </li>
                              <!-- <li class="dropdown-navbar"><a href="/libro">Libro </a> -->

                              <!-- <li class="dropdown-navbar"><a href="/inmaterial">Inmaterial</a> -->
                              <li class="dropdown-navbar arrow"><a href="/planmaestro">Plan Maestro</a>
                                <ul class="dropdown-nav">
                                    <li><a href="/planmaestro">Plan Maestro</a></li>
                                    <li><a href="/tomo-uno">Tomo I</a></li>
                                    <li><a href="/tomo-dos">Tomo II</a></li>
                                </ul>
                              </li>
                              <!-- <li class="dropdown-navbar"><a href="/fototeca">Fototeca</a> -->

                              <!-- <li class="dropdown-navbar arrow"><a href="/nosotros">Nosotros</a>
                                <ul class="dropdown-nav">
                                    <li><a href="/nosotros">Nosotros - Residencia</a></li>
                                    <li><a href="/sistemas">Componente de Informática/GIS</a></li>
                                    <li><a href="/social">Componente Social</a></li>
                                    <li><a href="/verificacion">Componente de Verificación</a></li>
                                    <li><a href="/comp-catalogacion">Componente de Catalogación</a></li>
                                </ul>
                              </li> -->
                              <li class="dropdown-navbar arrow"><a href="/gerencia">Gerencia</a>
                                <ul class="dropdown-nav">
                                    <li><a href="/gerencia">Gerencia</a></li>
                                    <li><a href="/requisitos">Requisitos Licencia</a></li>
                                    <li><a href="/contacto">Contáctanos</a></li>
                                    <hr>
                                    <li><a href="/nosotros">Nosotros - Residencia</a></li>
                                    <li><a href="/sistemas">Componente de Informática/GIS</a></li>
                                    <li><a href="/social">Componente Social</a></li>
                                    <li><a href="/verificacion">Componente de Verificación</a></li>
                                    <li><a href="/comp-catalogacion">Componente de Catalogación</a></li>
                                </ul>
                              </li>
                          </ul>
                      </nav>
                  </div>
                  <div class="off-canvas-area-wrap nav">
                    <button class="off-canvas-btn d-none d-lg-block"><i class="fa fa-bars"></i></button>
                    <button class="mobile-menu text-white d-lg-none"><i class="fa fa-bars"></i></button>
                  </div>
              </div>
          </div><!-- End Main Navigation Wrap -->
      </div>
  </div>
</header>

<!--  -->
